// extracted by mini-css-extract-plugin
export default {"buttons":"add-chat_buttons__w619g","add-chat":"add-chat_add-chat__E971E","--mobile":"add-chat_--mobile__MGyE7","button":"add-chat_button__N80Rm"};